var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeZero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-109.482 0-165 86.518-165 255.194 0 63.267 0 256.806 165 256.806 109.482 0 165-86.737 165-255.839 0-169.307-55.518-256.161-165-256.161zm0 105.707c45.26 0 42.349 104.904 42.349 150.454 0 45.233 3.176 150.132-42.349 150.132-45.361 0-42.349-104.514-42.349-150.132 0-45.363-3.228-150.454 42.349-150.454z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeZero);
export default __webpack_public_path__ + "static/media/badge_zero.8280c8b8cefe7f1aa7dd28d36c8d0bca.svg";
export { ForwardRef as ReactComponent };